import { render, staticRenderFns } from "./HanoiSamakkhi.vue?vue&type=template&id=5517ede8&"
import script from "./HanoiSamakkhi.vue?vue&type=script&lang=js&"
export * from "./HanoiSamakkhi.vue?vue&type=script&lang=js&"
import style0 from "./HanoiSamakkhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports